function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = parseFloat(this.input.step) || 1;
      this.changeEvent = new Event('change', { bubbles: true });

      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      this.subtract.addEventListener('click', () => this.changeQuantity(-this.step));
      this.add.addEventListener('click', () => this.changeQuantity(this.step));

      // Manual entry handling (no 'change' listener to avoid recursion)
      this.input.addEventListener('blur', () => this.clampAndMaybeDispatch({ dispatch: true }));
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          // Prevent form submit loops
          e.preventDefault();

          // Clamp value but do NOT dispatch synthetic 'change' here
          this.clampAndMaybeDispatch({ dispatch: false });

          // Force a native 'change' by blurring (what your theme listens to)
          requestAnimationFrame(() => {
            this.input.blur(); // triggers native change if value differs
            // Optional: restore focus so the cursor stays in the field
            requestAnimationFrame(() => this.input.focus({ preventScroll: true }));
          });
        }
      });

      // Optional: ensure clamped before form submit
      // const form = this.closest('form');
      // if (form) {
      //   form.addEventListener('submit', () => this.clampAndMaybeDispatch({ dispatch: true }));
      // }
    }

    connectedCallback() {
      this.classList.add('buttons_added');
      // Clamp silently on mount so a bad persisted value is corrected without firing change again
      this.clampAndMaybeDispatch({ dispatch: false });
      this.validateQtyRules();
    }

    getMin() {
      return this.input.min !== '' ? parseFloat(this.input.min) : 1;
    }
    getMax() {
      return this.input.max !== '' ? parseFloat(this.input.max) : Infinity;
    }

    changeQuantity(delta) {
      const min = this.getMin();
      const max = this.getMax();

      let quantity = parseFloat(this.input.value);
      if (isNaN(quantity)) quantity = min;

      let next = quantity + delta;
      if (next < min) next = min;
      if (next > max) next = max;

      if (next !== quantity) {
        this.input.value = next;
        this.input.dispatchEvent(this.changeEvent); // trigger cart update
        this.validateQtyRules();
      }
    }

    // Clamp to min/max/step. Dispatch change only if value actually changed and dispatch=true
    clampAndMaybeDispatch({ dispatch = false } = {}) {
      const min = this.getMin();
      const max = this.getMax();
      const step = this.step > 0 ? this.step : 1;

      const prev = this.input.value;
      let value = parseFloat(prev);
      if (isNaN(value)) value = min;

      // Clamp to min/max
      value = Math.max(min, Math.min(max, value));

      // Snap to step grid relative to min (optional, keeps multiples of step)
      const base = isFinite(min) ? min : 0;
      value = base + Math.floor((value - base) / step) * step;
      value = Math.max(min, Math.min(max, value));

      const changed = String(value) !== String(prev);

      if (changed) {
        this.input.value = value;
      }

      if (dispatch && changed) {
        // Dispatch once; we don't listen to 'change' ourselves so no recursion
        this.input.dispatchEvent(this.changeEvent);
      }

      this.validateQtyRules();
      return changed;
    }

    validateQtyRules() {
      const value = parseFloat(this.input.value);
      const min = this.getMin();
      const max = this.getMax();

      const atMin = value <= min;
      const atMax = isFinite(max) ? value >= max : false;

      this.subtract.classList.toggle('disabled', atMin);
      this.add.classList.toggle('disabled', atMax);

      // Also set real disabled attribute for accessibility
      this.subtract.toggleAttribute('disabled', atMin);
      this.add.toggleAttribute('disabled', atMax);
    }
  }

  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card--featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card--featured-image-link');
      let primary_image = this.querySelector('.product-primary-image'); // Get primary image

      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];

        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });

        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
            // Hide primary image when secondary image is hovered
            if (primary_image) {
              primary_image.style.display = 'none';
            }
          }
        }
      };

      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
        // Show primary image when mouse leaves
        if (primary_image) {
          primary_image.style.display = 'block';
        }
      };

      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });

        swatch.addEventListener('mouseover', () => {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }
          if (this.size_options) {
            this.current_options[this.color_index] = swatch.querySelector('span').innerText;
            this.updateMasterId();
          }
          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-card--featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }

        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}


/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');

      this.onClick = (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      };
      // Add functionality to buttons
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('panel:close', this.onClick.bind(this));
      if (!this.cc.hasAttribute('initialized')) {
        this.cc.addEventListener('click', this.onClick.bind(this));
        this.cc.setAttribute('initialized', '');
      }

    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel.active');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer') || document.body.classList.contains('open-quick-view')) {
        this.close_quick_view();
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view() {
      let panel = document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      let button = document.getElementById('cart-drawer-toggle');

      // Add functionality to buttons
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        this.classList.add('active');
        this.focus();
        setTimeout(() => {
          this.querySelector('.product-recommendations--full')?.classList.add('active');
        });
        dispatchCustomEvent('cart-drawer:open');
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.notesToggle();
      this.removeProductEvent();
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {
      // Remove old event listener if it exists
      this.removeEventListener('click', this._removeClickHandler);
      
      // Use event delegation for better handling of dynamically added elements
      this._removeClickHandler = (event) => {
        const removeButton = event.target.closest('.remove');
        if (removeButton) {
          const index = removeButton.dataset.index;
          if (index !== undefined) {
            this.updateQuantity(index, '0');
            event.preventDefault();
          }
        }
      };
      
      this.addEventListener('click', this._removeClickHandler);
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    notesToggle() {
      const notes_toggle = document.getElementById('order-note-toggle');

      if (!notes_toggle) {
        return;
      }

      notes_toggle.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.add('active');
      });
      notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
        el.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.remove('active');
          this.saveNotes();
        });
      });
    }
    saveNotes() {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': document.getElementById('mini-cart__notes').value
        })
      });
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      this.querySelector('.product-recommendations--full')?.classList.remove('active');

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.removeProductEvent();
          this.notesToggle();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
        });
    }
    refresh() {
      this.querySelector('.product-recommendations--full')?.classList.remove('active');
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
          this.notesToggle();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function ProductCardATC
 */
if (!customElements.get('product-card-atc')) {
  class ProductCardATC extends HTMLElement {
    constructor() {
      super();
      // Bind once so we can add/remove the same handler reliably
      this._onClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      console.log('ATC button connected');
      this.addEventListener('click', this._onClick);
      this.originalText =
        this.querySelector('span:last-child')?.textContent ||
        this.textContent?.trim() ||
        'Add to cart';

      // Check initial inventory status
      this.checkInventoryStatus();
    }

    handleClick(e) {
      e.preventDefault();
      e.stopPropagation();

      console.log('ATC button clicked');

      // Check if button is disabled due to inventory
      if (this.classList.contains('out-of-stock') || this.hasAttribute('disabled')) {
        console.log('Product is out of stock or at max, ignoring click');
        return;
      }

      if (this.classList.contains('loading')) {
        console.log('Already loading, ignoring click');
        return;
      }

      const productId = this.dataset.productId;
      const productHandle = this.dataset.productHandle;

      console.log('Product ID:', productId, 'Handle:', productHandle);

      if (!productId) {
        console.error('Product ID not found');
        return;
      }

      this.addToCart(productId, productHandle);
    }

    async checkInventoryStatus() {
      try {
        const productHandle = this.dataset.productHandle;
        const variantId = this.dataset.productId;

        if (!productHandle || !variantId) return;

        // Fetch product data to check inventory (force fresh)
        const response = await fetch(`/products/${productHandle}.js`, { cache: 'no-store' });
        if (response.ok) {
          const product = await response.json();

          // Find the specific variant
          const variant = product.variants.find(v => v.id.toString() === variantId.toString());

          if (variant) {
            const isTracked = Boolean(variant.inventory_management); // null/undefined = not tracked
            const continueSelling = variant.inventory_policy === 'continue';
            const qty = typeof variant.inventory_quantity === 'number'
              ? variant.inventory_quantity
              : Number(variant.inventory_quantity);

            // If variant itself isn't available, disable
            if (!variant.available) {
              this.disableButton('Out of Stock');
              return;
            }

            // If inventory is tracked and overselling is denied, enforce quantity
            if (isTracked && !continueSelling && Number.isFinite(qty) && qty <= 0) {
              this.disableButton('Out of Stock');
              return;
            }

            // Otherwise (not tracked, or continue selling, or qty > 0), proceed
            await this.checkCartQuantity(variant);
          }
        }
      } catch (error) {
        console.error('Error checking inventory:', error);
      }
    }

    async checkCartQuantity(variant) {
      try {
        // Get current cart (force fresh)
        const response = await fetch('/cart.js', { cache: 'no-store' });
        const cart = await response.json();

        // Find this variant in cart
        const cartItem = cart.items.find(item => item.variant_id.toString() === variant.id.toString());
        // Only treat inventory_quantity as authoritative when inventory is actually tracked
        const isTracked = Boolean(variant.inventory_management);
        const hasInventoryNumber = isTracked && typeof variant.inventory_quantity === 'number';

        if (cartItem && hasInventoryNumber) {
          // Check if cart quantity equals or exceeds available inventory (only for tracked variants)
          if (cartItem.quantity >= variant.inventory_quantity) {
            this.disableButton('Maximum in cart');
          } else {
            // If quantity is less than inventory, enable the button
            this.enableButton();
          }
        } else {
          // If item is not in cart OR inventory is not tracked, ensure button stays enabled
          this.enableButton();
        }
      } catch (error) {
        console.error('Error checking cart quantity:', error);
      }
    }

    disableButton(text = 'Out of Stock') {
      if (!this.classList.contains('disabled')) {
        this.classList.add('out-of-stock', 'disabled');
        this.setAttribute('disabled', '');
        this.setAttribute('aria-disabled', 'true');

        // Update button text
        this.updateButtonText(text);

        // Remove click event listener to prevent any interaction
        this.removeEventListener('click', this._onClick);
      }
    }

    enableButton() {
      if (this.classList.contains('disabled')) {
        this.classList.remove('out-of-stock', 'disabled');
        this.removeAttribute('disabled');
        this.removeAttribute('aria-disabled', '');

        // Restore original text
        this.updateButtonText(this.originalText);

        // Re-add click event listener
        this.addEventListener('click', this._onClick);
      }
    }

    updateButtonText(text) {
      const span = this.querySelector('span:last-child');
      if (span) {
        span.textContent = text;
      }
    }

    async addToCart(variantId, productHandle) {
      try {
        console.log('Starting add to cart for variant:', variantId);
        this.setLoadingState(true);

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        console.log('Add to cart response status:', response.status);

        if (!response.ok) {
          const errorData = await response.json();
          console.error('Add to cart failed:', errorData);

          // Check if error is about quantity limit or inventory
          if (errorData.description &&
            (errorData.description.includes('maximum quantity') ||
              errorData.description.includes('already in your cart') ||
              errorData.description.includes('only have') ||
              errorData.description.includes('available'))) {
            // Disable button for inventory limitations
            this.disableButton('Maximum in cart');
          } else if (errorData.description &&
            (errorData.description.toLowerCase().includes('available') ||
              errorData.description.toLowerCase().includes('inventory'))) {
            // Product is out of stock - disable button
            this.disableButton('Out of Stock');
          }
          return;
        }

        const data = await response.json();
        console.log('Add to cart success:', data);

        // Update cart count first (force fresh)
        await this.updateCartCount();
        // Small delay to let Shopify propagate state in some browsers
        await new Promise(r => setTimeout(r, 80));

        // Re-check inventory/cart against fresh data
        await this.checkInventoryStatus();

        // Success feedback only if still enabled (not at max/out-of-stock)
        if (!this.hasAttribute('disabled') && !this.classList.contains('disabled')) {
          this.showSuccessState();
        }

        // Dispatch custom event for cart updates
        this.dispatchCartEvent('cart:item-added', {
          variant_id: variantId,
          product_handle: productHandle,
          item: data
        });

        // Refresh cart content and open drawer
        await this.refreshCartAndOpenDrawer();

      } catch (error) {
        console.error('Add to cart error:', error);
      } finally {
        // IMPORTANT: Always remove loading state in finally block
        this.setLoadingState(false);
      }
    }

    async refreshCartAndOpenDrawer() {
      try {
        // Refresh cart content BEFORE opening drawer
        await this.refreshCartContent();

        // Open cart drawer AFTER content is refreshed
        this.openCartDrawer();

      } catch (error) {
        console.error('Error refreshing cart and opening drawer:', error);
        // Even if refresh fails, try to open drawer
        this.openCartDrawer();
      }
    }

    async refreshCartContent() {
      try {
        console.log('Refreshing cart content...');

        // Refresh cart drawer content
        const cartDrawer = document.querySelector('#CartDrawer, [data-cart-drawer], .cart-drawer');
        if (cartDrawer) {
          // Get the cart drawer section
          const response = await fetch('/?section_id=cart-drawer', { cache: 'no-store' });
          if (response.ok) {
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newCartDrawer = doc.querySelector('#CartDrawer, [data-cart-drawer], .cart-drawer');

            if (newCartDrawer) {
              // Replace the entire cart drawer content
              cartDrawer.innerHTML = newCartDrawer.innerHTML;
              console.log('Cart drawer content refreshed successfully');

              // Re-initialize any cart drawer functionality
              this.initializeCartDrawer();
              
              // Re-initialize the CartDrawer custom element methods
              this.reInitializeCartDrawerMethods();
            }
          } else {
            console.error('Failed to fetch cart drawer section');
          }
        } else {
          console.log('No cart drawer found to refresh');
        }

        // Refresh mini cart if exists
        const miniCart = document.querySelector('.mini-cart, [data-mini-cart]');
        if (miniCart) {
          const response = await fetch('/?section_id=mini-cart', { cache: 'no-store' });
          if (response.ok) {
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newMiniCart = doc.querySelector('.mini-cart, [data-mini-cart]');

            if (newMiniCart) {
              miniCart.innerHTML = newMiniCart.innerHTML;
              console.log('Mini cart content refreshed');
            }
          }
        }

        // Try to refresh the cart bubble (header count) section so header updates without full page refresh
        try {
          const bubbleResponse = await fetch('/?section_id=cart-bubble', { cache: 'no-store' });
          if (bubbleResponse.ok) {
            const bubbleHtml = await bubbleResponse.text();
            const bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
            const newBubble = bubbleDoc.querySelector('.thb-item-count, [data-cart-bubble], .cart-bubble');
            if (newBubble) {
              // Replace any existing bubble elements in the page
              const existingBubbles = document.querySelectorAll('.thb-item-count, [data-cart-bubble], .cart-bubble');
              existingBubbles.forEach(el => {
                // If the incoming fragment is a wrapper, copy its innerHTML; otherwise copy text
                el.innerHTML = newBubble.innerHTML || newBubble.textContent;
              });
              console.log('Cart bubble refreshed');
            }
          }
        } catch (e) {
          // Non-fatal: bubble refresh failed
          console.warn('Failed to refresh cart bubble:', e);
        }

        // Ensure global cart counts are consistent and notify listeners
        const cart = await this.updateCartCount();
        if (cart) {
          this.dispatchCartEvent('cart:updated', cart);
        }

      } catch (error) {
        console.error('Error refreshing cart content:', error);
        throw error; // Re-throw to handle in calling function
      }
    }

    initializeCartDrawer() {
      // Re-initialize cart drawer functionality after refresh
      const cartDrawer = document.querySelector('#CartDrawer, [data-cart-drawer], .cart-drawer');
      if (!cartDrawer) return;

      // Re-attach close button events
      const closeButtons = cartDrawer.querySelectorAll('.side-panel-close, [data-cart-close], .drawer-close, .close-button');
      closeButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeCartDrawer();
        });
      });

      console.log('Cart drawer re-initialized');
    }

    reInitializeCartDrawerMethods() {
      // Get the actual CartDrawer custom element to call its methods
      const cartDrawerElement = document.querySelector('cart-drawer');
      if (!cartDrawerElement) {
        console.log('CartDrawer custom element not found');
        return;
      }

      // Call the CartDrawer methods to reattach event listeners
      if (typeof cartDrawerElement.removeProductEvent === 'function') {
        cartDrawerElement.removeProductEvent();
        console.log('Remove product events reattached');
      }

      if (typeof cartDrawerElement.notesToggle === 'function') {
        cartDrawerElement.notesToggle();
        console.log('Notes toggle reattached');
      }
    }

    openCartDrawer() {
      console.log('Opening cart drawer...');

      const cartDrawer = document.querySelector('#CartDrawer, [data-cart-drawer], .cart-drawer, .side-panel[data-panel="cart"]');

      if (cartDrawer) {
        // Add body classes
        document.body.classList.add('open-cc', 'cart-open', 'open-cart', 'drawer-open');

        // Add drawer classes
        cartDrawer.classList.add('active', 'open', 'is-open');

        // Set aria attributes
        cartDrawer.setAttribute('aria-hidden', 'false');

        console.log('Cart drawer opened successfully with updated content');

        // Dispatch event for other components to know drawer is open
        this.dispatchCartEvent('cart:drawer-opened', {});

      } else {
        console.log('Cart drawer not found after refresh');

        // Try to click cart button as fallback
        const cartButton = document.querySelector('[data-cart-toggle], .cart-toggle, .header-cart, .cart-icon');
        if (cartButton) {
          cartButton.click();
          console.log('Cart drawer opened via cart button click');
        }
      }
    }

    closeCartDrawer() {
      const cartDrawer = document.querySelector('#CartDrawer, [data-cart-drawer], .cart-drawer');

      if (cartDrawer) {
        document.body.classList.remove('open-cc', 'cart-open', 'open-cart', 'drawer-open');
        cartDrawer.classList.remove('active', 'open', 'is-open');
        cartDrawer.setAttribute('aria-hidden', 'true');

        this.dispatchCartEvent('cart:drawer-closed', {});
      }
    }

    setLoadingState(loading) {
      console.log('Setting loading state:', loading);
      if (loading) {
        this.classList.add('loading');
      } else {
        // Force remove loading class with a small delay to ensure it's removed
        setTimeout(() => {
          this.classList.remove('loading');
          console.log('Loading state removed');
        }, 100);
      }
    }

    showSuccessState() {
      const span = this.querySelector('span:last-child');
      if (!span) return;

      // If button is disabled (e.g., Maximum in cart), skip the success flash
      if (this.hasAttribute('disabled') || this.classList.contains('disabled')) return;

      this.classList.add('success');
      span.textContent = 'Added!';

      setTimeout(() => {
        this.classList.remove('success');
        // Only restore original text if still enabled
        if (!this.hasAttribute('disabled') && !this.classList.contains('disabled')) {
          span.textContent = this.originalText;
        }
        console.log('Success state removed');
      }, 2000);
    }

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js', { cache: 'no-store' });
        const cart = await response.json();

        // Update common cart count targets (theme variations)
        const cartCounts = document.querySelectorAll('[data-cart-count], .cart-count, #cart-count, .thb-item-count');
        cartCounts.forEach(count => {
          if (count) {
            // If the element is a wrapper, write the numeric value; otherwise replace text
            count.textContent = cart.item_count;
            count.setAttribute('data-cart-count', cart.item_count);
          }
        });

        // Update any badge-style elements
        const cartBadges = document.querySelectorAll('.cart-badge, [data-cart-badge], .thb-cart-badge');
        cartBadges.forEach(badge => {
          if (badge) {
            badge.textContent = cart.item_count;
            badge.style.display = cart.item_count > 0 ? 'block' : 'none';
          }
        });

        return cart;

      } catch (error) {
        console.error('Error updating cart count:', error);
        return null;
      }
    }

    dispatchCartEvent(eventName, detail) {
      const event = new CustomEvent(eventName, {
        detail: detail,
        bubbles: true,
        cancelable: true
      });
      document.dispatchEvent(event);
    }
  }

  customElements.define('product-card-atc', ProductCardATC);
  console.log('ProductCardATC custom element defined');
}

// Global event listeners for cart updates
document.addEventListener('DOMContentLoaded', function () {
  console.log('Initializing cart listeners');
  initializeGlobalCartListeners();
});

function initializeGlobalCartListeners() {
  // Listen for all cart interactions
  document.addEventListener('click', function (e) {
    // Quantity buttons
    if (e.target.closest('.minus') || e.target.closest('.plus')) {
      console.log('Quantity button clicked');
      setTimeout(() => {
        refreshAllATCButtons();
      }, 800);
    }

    // Remove buttons
    if (e.target.closest('.remove')) {
      console.log('Remove button clicked');
      setTimeout(() => {
        refreshAllATCButtons();
      }, 800);
    }

    // Quantity input changes
    if (e.target.classList.contains('qty')) {
      console.log('Quantity input changed');
      clearTimeout(window.quantityInputTimeout);
      window.quantityInputTimeout = setTimeout(() => {
        refreshAllATCButtons();
      }, 1000);
    }
  });

  // Listen for cart update events
  document.addEventListener('cart:updated', function () {
    console.log('Cart updated event received');
    setTimeout(() => {
      refreshAllATCButtons();
    }, 500);
  });

  document.addEventListener('ajaxCart:updated', function () {
    console.log('AJAX cart updated event received');
    setTimeout(() => {
      refreshAllATCButtons();
    }, 500);
  });
}

function refreshAllATCButtons() {
  console.log('Refreshing all ATC buttons');
  const allATCButtons = document.querySelectorAll('product-card-atc');
  let refreshedCount = 0;

  allATCButtons.forEach(button => {
    if (button.checkInventoryStatus && typeof button.checkInventoryStatus === 'function') {
      button.checkInventoryStatus();
      refreshedCount++;
    }
  });

  console.log(`Refreshed ${refreshedCount} ATC buttons`);
}

// Refresh ATC buttons when coming back to the page
document.addEventListener('visibilitychange', function () {
  if (!document.hidden) {
    console.log('Page visible, refreshing ATC buttons');
    setTimeout(() => {
      refreshAllATCButtons();
    }, 500);
  }
});

// Emergency loading state cleanup - if any buttons are stuck in loading state
document.addEventListener('DOMContentLoaded', function () {
  // Clean up any stuck loading states after page load
  setTimeout(() => {
    const stuckLoadingButtons = document.querySelectorAll('product-card-atc.loading');
    if (stuckLoadingButtons.length > 0) {
      console.log(`Cleaning up ${stuckLoadingButtons.length} stuck loading buttons`);
      stuckLoadingButtons.forEach(button => {
        button.classList.remove('loading');
      });
    }
  }, 2000);
});


/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container').classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});

// MAC RIGHT ARROW
document.addEventListener('DOMContentLoaded', function () {
  var ua = navigator.userAgent;

  var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  var isSafari = ua.includes('Safari') && !ua.includes('Chrome') && !ua.includes('Chromium') && !ua.includes('Firefox');

  if (isMac && isSafari) {
    document.documentElement.classList.add('mac-safari');
  }
});

// FOR COLLECTION PAGE RIGHT ARROW 
document.addEventListener('DOMContentLoaded', function () {
  var ua = navigator.userAgent;

  var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  var isSafari = ua.includes('Safari') && !ua.includes('Chrome') && !ua.includes('Chromium') && !ua.includes('Firefox');

  if (isMac && isSafari) {
    document.documentElement.classList.add('mac-safari');
  }
});